import React from "react";
import { withRouter } from "react-router-dom";
import ASICDept from "./ASICDept.Component";

const ASICDeptLanding = () => {
  return <ASICDept />;
};
export default withRouter(ASICDeptLanding);
